/* eslint-disable no-case-declarations */
import { REMOVE_NOTIFICATION } from '../actions/types/CapeActionTypes';
import { LOGGED_OUT } from '../../../../core/modules/security/redux/actions/types/SecurityActionTypes';

const initialState = {
  errors: [],
};

export default (state = initialState, action) => {
  switch (true) {
    case action && action.type && action.type.endsWith('_FAILURE') && action.type === 'REPORT_LOAD_DATA_FAILURE':
      let message;
      if (action.payload.error.response.data.TechnicalError !== undefined) {
        const { messageKey } = action.payload.error.response.data.TechnicalError;
        if (messageKey === 'user.email.notregistered') {
          message = 'No e-mail address has been associated with your account. Please contact IPC helpdesk (helpdesk@ipc.be) to register your e-mail.';
        } else {
          message = 'Your request failed due to technical issues at IPC. Pls resubmit your request or contact IPC helpdesk (helpdesk@ipc.be) in case of repeated issues.';
        }
      } else {
        message = action.type;
      }
      return {
        ...state,
        errors: [`An error occurred while attempting to contact the server (Error code ${message})`],
      };
    case action && action.type && action.type === REMOVE_NOTIFICATION:
      return {
        ...state,
        errors: [],
      };
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};
